// 사용자 주석 — 정의 목록과 연결별 영역(영역 조회 쿼리 결과). persist 하지 않는다(로그인·연결 때 다시 받는다).
import {
    UCMT_DEFS_LOADED, UCMT_AREAS_START, UCMT_AREAS_DONE, UCMT_AREAS_RESET, UCMT_AREAS_CLEAR,
} from '../actions/userCommentActions';

const initialState = {
    defs: [],
    defsLoaded: false,
    // { [connectionId]: { status: 'loading'|'ok'|'error', areas: [{ id, name, defId, defName }], errors: [] } }
    areasByConn: {},
};

export default function userCommentReducer(state = initialState, action) {
    switch (action.type) {
        case UCMT_DEFS_LOADED:
            return { ...state, defs: action.payload || [], defsLoaded: true };
        case UCMT_AREAS_START:
            return { ...state, areasByConn: { ...state.areasByConn, [action.connectionId]: { status: 'loading', areas: [], errors: [] } } };
        case UCMT_AREAS_DONE:
            return { ...state, areasByConn: { ...state.areasByConn, [action.connectionId]: { status: action.error ? 'error' : 'ok', areas: action.areas || [], errors: action.errors || [], error: action.error || null } } };
        case UCMT_AREAS_CLEAR: {
            // 실패한 연결만 지운다 — 그사이 다시 받아 성공했으면 그대로 둔다
            const cur = state.areasByConn[action.connectionId];
            if (!cur || (cur.status !== 'error' && !(cur.errors && cur.errors.length))) return state;
            const next = { ...state.areasByConn };
            delete next[action.connectionId];
            return { ...state, areasByConn: next };
        }
        case UCMT_AREAS_RESET:
            return { ...state, areasByConn: {} };
        default:
            return state;
    }
}
